import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Mail } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_sandbar-coffee/artifacts/c3buqejl_Larger%20SBC%20Logo%20transparent.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <img src={LOGO_URL} alt="Sandbar Coffee" className="footer-logo" />
        <p className="body-small" style={{ marginBottom: '2rem', opacity: 0.9 }}>
          Where Calm Meets Caffeine
        </p>

        <div className="footer-social">
          <a href="https://instagram.com/sandbarcoffee242" target="_blank" rel="noopener noreferrer" className="social-link" data-testid="footer-instagram">
            <Instagram size={24} />
          </a>
          <a href="mailto:hello@sandbarcoffee.co" className="social-link" data-testid="footer-email">
            <Mail size={24} />
          </a>
        </div>

        <div className="footer-links">
          <a href="/#about">About</a>
          <a href="/#services">Events</a>
          <a href="/#packages">Services</a>
          <Link to="/menu" data-testid="footer-menu">What We Serve</Link>
          <a href="/#faq">FAQ</a>
          <Link to="/book" data-testid="footer-book-event">Get a Quote</Link>
        </div>

        <div className="footer-bottom">
          <p className="caption">
            © {new Date().getFullYear()} Sandbar Coffee. Nassau, Bahamas.
          </p>
          <p className="caption" style={{ marginTop: '0.5rem' }}>
            Mobile Espresso Bar • Private &amp; Public Events • Catering Services
          </p>
        </div>
      </div>
    </footer>
  );
};
